import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Header from "../Components/Header";
import axios from "axios";

const ViewCustomer = () => {
  const { user_id } = useParams(); // Get user_id from URL params
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);
  const [agent, setAgent] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}customer_detail.php`, { user_id });
        if (response.data.head.code === 200) {
          setCustomer(response.data.body);
        } else {
          console.error("Error fetching customer details:", response.data.head.msg);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    fetchCustomer();
  }, [user_id]);

   useEffect(() => {
  const fetchAgent = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}agent_list.php`);
      if (response.data.head.code === 200) {
        setAgent(response.data.body);
      } else {
        console.error("Error fetching agent list:", response.data.head.msg);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  fetchAgent();
}, []); // ✅ Empty array to run only once on mount

  const handleChange = (e) => {
    setCustomer({ ...customer, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}customer_detail_update.php`, {
        user_id,
        name: customer.name,
        credit_limit: customer.credit_limit,
        tax_number: customer.tax_number,
        aadhar_number: customer.aadhar_number,
        telephone: customer.mobile, // Assuming mobile = telephone
        address: customer.address,
        agent: customer.agent,
        state:customer.state,
      });
      if (response.data.head.code === 200) {
        alert("Customer details updated successfully!");
        navigate("/customerlist");
      } else {
        alert("Failed to update customer details: " + response.data.head.msg);
      }
    } catch (error) {
      console.error("API Error:", error);
      alert("An error occurred while updating customer details.");
    }
  };

  if (!customer) {
    return <p>Loading customer details...</p>;
  }

  return (
    <>
      <Header />
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-body-wrapper">
          <div className="page-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-sm-12 m-auto">
                      <div className="card">
                        <div className="card-body">
                          <div className="title-header option-title d-sm-flex d-block">
                            <h5>View Customer</h5>
                            <div className="right-options">
                              <ul>
                                <li>
                                  <Link className="btn btn-solid" to="/customerlist">Back</Link>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <form className="theme-form theme-form-2 mega-form" onSubmit={handleSubmit}>
                            <div className="mb-4 row align-items-center">
                              <label className="form-label-title col-sm-3 mb-0">Agent</label>
                              <div className="col-sm-9">
                                <select
                                  className="form-control"
                                  name="agent"
                                  value={customer.agent || ""}
                                  onChange={handleChange}
                                  required
                                >
                                  <option value="">Select Agent</option>
                                  {agent && agent.map((item) => (
                                    <option key={item.agent_name} value={item.agent_name}>
                                      {item.agent_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="mb-4 row align-items-center">
                              <label className="form-label-title col-sm-3 mb-0">Name</label>
                              <div className="col-sm-9">
                                <input className="form-control" type="text" name="name" value={customer.name || ""} onChange={handleChange} required />
                              </div>
                            </div>
                            <div className="mb-4 row align-items-center">
                              <label className="form-label-title col-sm-3 mb-0">Address</label>
                              <div className="col-sm-9">
                                <textarea rows="3" className="form-control" name="address" value={customer.address || ""} onChange={handleChange} required></textarea>
                              </div>
                            </div>
                                <div className="mb-4 row align-items-center">
                              <label className="form-label-title col-sm-3 mb-0">State</label>
                              <div className="col-sm-9">
                                <input className="form-control" type="text" name="state" value={customer.state || ""} onChange={handleChange} required />
                              </div>
                            </div>

                            <div className="mb-4 row align-items-center">
                              <label className="form-label-title col-sm-3 mb-0">Phone Number</label>
                              <div className="col-sm-9">
                                <input className="form-control" type="text" name="mobile" value={customer.mobile || ""}
                                 onChange={handleChange} 
                                 required 
                                 maxLength="10"
                                 onInput={(e) => {
                                   e.target.value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                                   if (e.target.value.length > 10) {
                                       e.target.value = e.target.value.slice(0, 10); // Limit to 10 digits
                                   }
                               }}
                                 />
                              </div>
                            </div>
                        
                            <div className="mb-4 row align-items-center">
                              <label className="form-label-title col-sm-3 mb-0">GST Number</label>
                              <div className="col-sm-9">
                                <input className="form-control" type="text" name="tax_number" value={customer.tax_number || ""} onChange={handleChange}   maxLength="15"  />
                              </div>
                            </div>

                            <div className="mb-4 row align-items-center">
                              <label className="form-label-title col-sm-3 mb-0">Aadhar Number</label>
                              <div className="col-sm-9">
                                <input className="form-control" type="text" name="aadhar_number" value={customer.aadhar_number || ""} onChange={handleChange}   maxLength="12"  />
                              </div>
                            </div>

                            <div className="card-footer border-0 pb-0 d-flex justify-content-end">
                              <button className="btn btn-primary me-3" type="submit">Submit</button>
                              <button className="btn btn-outline" type="button" onClick={() => window.history.back()}>Cancel</button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCustomer;
